import { Timestamp } from '@griply/types';

export enum DeletedFilter {
  IncludeDeleted = 'includeDeleted',
  OnlyDeleted = 'onlyDeleted',
  ExcludeDeleted = 'excludeDeleted',
}

export type DeletedFilterOption = {
  deletedFilter?: DeletedFilter;
};

export const selectByDeletedFilter = <
  T extends { deletedAt?: Timestamp | null },
>(
  items: T[] | undefined,
  filter: DeletedFilter,
): T[] | undefined => {
  if (!items) {
    return items;
  }

  if (filter === DeletedFilter.IncludeDeleted) {
    return items;
  }

  if (filter === DeletedFilter.OnlyDeleted) {
    return items.filter(({ deletedAt }) => !!deletedAt);
  }

  return items.filter(({ deletedAt }) => !deletedAt);
};
